import { reactive } from "vue";
import {
  chatDividerClasses,
  chatGroupMetaClasses,
  chatAvatarClasses,
  chatBubbleClasses,
  chatStreamingCursorClasses,
  chatTypingIndicatorClasses,
  chatTypingDotClasses,
  chatAttachmentImageClasses,
  chatAttachmentFileClasses,
  chatAttachmentFileExtClasses,
  chatAttachmentLinkClasses,
  chatAttachmentLinkImageClasses,
  chatAttachmentLinkBodyClasses,
} from "./chat.styles";

export const useChatVirtualItem = () => {
  // Pre-compute static classes — avoids re-invoking on every render.
  const dividerCls = chatDividerClasses({});
  const metaCls = chatGroupMetaClasses({});
  const avatarCls = chatAvatarClasses({});
  const bubbleLeftCls = chatBubbleClasses({ side: "left" });
  const bubbleRightCls = chatBubbleClasses({ side: "right" });
  const cursorCls = chatStreamingCursorClasses({});
  const typingCls = chatTypingIndicatorClasses({});
  const dotCls = chatTypingDotClasses({});
  const attImageCls = chatAttachmentImageClasses({});
  const attFileCls = chatAttachmentFileClasses({});
  const attFileExtCls = chatAttachmentFileExtClasses({});
  const attLinkCls = chatAttachmentLinkClasses({});
  const attLinkImgCls = chatAttachmentLinkImageClasses({});
  const attLinkBodyCls = chatAttachmentLinkBodyClasses({});

  // Per-item image load state, keyed by `${msgId}-${attachmentIndex}` to avoid
  // shared state when the same URL appears in multiple messages.
  const loadedImages = reactive<Record<string, boolean>>({});

  const onImageLoad = (key: string): void => {
    loadedImages[key] = true;
  };

  return {
    dividerCls,
    metaCls,
    avatarCls,
    bubbleLeftCls,
    bubbleRightCls,
    cursorCls,
    typingCls,
    dotCls,
    attImageCls,
    attFileCls,
    attFileExtCls,
    attLinkCls,
    attLinkImgCls,
    attLinkBodyCls,
    loadedImages,
    onImageLoad,
  };
};
